import { ref } from 'vue';
import type { Url } from '../../types/url.ts';

const cache = new Map<string, Promise<string>>();

export const useIconCache = (name: string) => {
  const svgUrl = ref<Url | null>(null);

  const setSvgUrl = async (): Promise<void> => {
    try {
      if (!cache.has(name)) {
        cache.set(
          name,
          import(`@icons/sprite/${name}.svg`).then(module => module.default)
        );
      }

      svgUrl.value = await cache.get(name)!;
    } catch (error) {
      console.error(`The icon ${name} does not exist`);
    }
  };

  void setSvgUrl();

  return {
    svgUrl,
    cache,
  };
};
